import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { MessageService } from '@services/helpers/message-service/message.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'modal-delete-quote',
	template: require('./modal-delete-quote.html'),
	styles: [require('./modal-delete-quote.scss')]
})
export class ModalDeleteQuoteComponent {
	@Input() jobId;
	@Input() leadId;
	@Input() quoteId;
	@Input() isLead;
	disableButtons: boolean;

	constructor(
		private messageService: MessageService,
		private quotesDataService: QuotesDataProvider,
		private location: Location
	) {}

	deleteQuote(): void {
		this.disableButtons = true;

		this.quotesDataService
			.deleteQuote(this.jobId, this.quoteId)
			.pipe(finalize((): boolean => (this.disableButtons = false)))
			.subscribe(
				(data): void => this.successDeleteQuote(data),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private successDeleteQuote(data): void {
		const { errorMessage, errorTitle } = data;
		if (errorMessage) {
			this.messageService.showErrorFromBackend(errorTitle, errorMessage);
			return;
		}

		this.messageService.showToaster('s_5', 'payments');
		this.redirectOnSuccess();
		$('#deleteQuoteModal').modal('hide');
	}

	private redirectOnSuccess(): void {
		if (this.isLead === true) {
			this.location.go(`leads/view/${this.leadId}`);
		} else {
			this.location.go(`jobs/view/${this.jobId}`);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.ts